<template>
  <v-row>
    <v-col cols="12">
      <v-skeleton-loader
        v-if="!initiated"
        ref="skeleton"
        type="table"
        class="mx-auto"
      ></v-skeleton-loader>
      <v-row class="toolbar" dense v-if="initiated" >
        <v-col cols="8" md="4">
          <v-text-field
            class="search-input"
            hide-details
            prepend-icon="mdi-text-search"
            single-line
            v-model="search"
            @keyup.enter.native="loadTable()"
          ></v-text-field>
        </v-col>
        <v-col cols="4" md="2">
          <v-btn small color="primary" @click="loadTable()" class="v-btn-search">Search</v-btn>
        </v-col>
      </v-row>
      <v-data-table
        v-if="initiated"
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="elevation-1"
        :footer-props="{
          'items-per-page-options': [30,60,100,150,250],
        }"
      >
        <template v-slot:item.actions="{ item }">
          <v-btn
            x-small
            color="success"
            @click="accessServices(item)"
          >
            Access Services
          </v-btn>&nbsp;&nbsp;
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'AgentTicketList',
  components: {
  },
  data() {
    return {
      search: '',
      initiated: false,
      productTypeId: null,
      productTypes: [],
      totalItems: 0,
      items: [],
      strange: false,
      loading: true,
      options: {
        page: 1,
        itemsPerPage: 30,
      },
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Ticket', value: 'ticket_id' },
        { text: 'Domain', value: 'domain' },
        { text: 'Purpose', value: 'purpose' },
        { text: 'User Email', value: 'email' },
        { text: 'Date', value: 'created_at' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler() {
        if (this.initiated) {
          this.loadTable();
        }
      },
      deep: true,
    },
  },
  created() {
    this.loadTable();
  },
  methods: {
    accessServices(item) {
      this.$router.push({ name: 'AgentTicketServiceList', params: { id: item.id } });
    },
    loadTable() {
      const {
        sortBy, sortDesc, page, itemsPerPage,
      } = this.options;
      this.loading = true;
      this.$api.post('agent/ticket/list', {
        search: {
          '*': this.search,
        },
        current_page: page,
        per_page: itemsPerPage,
        product_type_id: this.productTypeId,
        order: `${sortBy}:${sortDesc}`,
      }).then((response) => {
        this.totalItems = response.data.total;
        this.items = response.data.data;
        this.loading = false;
        this.initiated = true;
      });
    },
  },
};
</script>

<style scoped>
  table td {
    font-size: 0.75rem !important;
  }

  .product-type-tab .v-tab {
    justify-content: flex-start;
  }

  .product-type-tab .v-chip {
    margin-right: 8px;
  }

  .toolbar {
    margin-bottom: 8px;
  }

  .search-input {
    padding: 0 !important;
  }

  .v-btn-search {
    margin-top: 10px;
    margin-right: 4px;
  }

  .v-btn-more {
    margin-top: 10px;
  }
</style>
